import { render, staticRenderFns } from "./ReportSimNewness.vue?vue&type=template&id=40295d3f&"
import script from "./ReportSimNewness.vue?vue&type=script&lang=js&"
export * from "./ReportSimNewness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports